import { createAsyncThunk } from "@reduxjs/toolkit";
import { connection, log } from "./shared";

export const leaveSignalRRoom = createAsyncThunk<
  { roomId: string },
  string,
  { rejectValue: string }
>("signalr/leaveRoom", async (roomId, { rejectWithValue }) => {
  if (!connection) {
    log("leaveSignalRRoom: no active connection", { roomId });
    return rejectWithValue("Connection not established");
  }
  try {
    log("leaveSignalRRoom: invoking LeaveRoomAsync", { roomId });
    const fullRoomId = `workflow:${roomId}`;
    await connection.invoke("LeaveRoomAsync", fullRoomId);
    log("leaveSignalRRoom: successfully left room", { roomId });
    return { roomId };
  } catch (e: unknown) {
    const message = e instanceof Error ? e.message : String(e);
    log("leaveSignalRRoom: ERROR", { roomId, message });
    return rejectWithValue(message || `Failed to leave room ${roomId}`);
  }
});
